import BaseSingle from "../../../engines/libs/BaseSingle";
import { ConditionKind } from "../../define/ConditionKind";
import NormalGameManager from "./NormalGameManager";

export default class DataVariationManage extends BaseSingle{
    static get instance() {
        return super.GetInstance<DataVariationManage>();
    }   

    updateData(dataType: ConditionKind.ConditionsType, ...arg: any[]) {
        NormalGameManager._instance.taskDataManage.updateData(dataType, ...arg);
    }
}